<ion-segment
  data-cy="pdp-summary-mode-selector"
  mode="ios"
  value="CUSTOMER_PAGE_INDEX"
  (ionChange)="setSelectedSegment($event)"
>
  <ion-segment-button
    appTestId="pdp-summary-overview-mode-button"
    data-cy="pdp-summary-overview-mode-button"
    value="CUSTOMER_PAGE_INDEX"
  >
    <ion-label data-cy="pdp-overview-mode-button-text">
      {{ 'i18n.productDetail.productOverview' | translate }}
    </ion-label>
  </ion-segment-button>
  <ion-segment-button
    appTestId="pdp-summary-seller-mode-button"
    data-cy="pdp-summary-seller-mode-button"
    value="SELLER_PAGE_INDEX"
  >
    <ion-label data-cy="pdp-seller-mode-button-text">
      {{ 'i18n.productDetail.sellerDetails' | translate }}
    </ion-label>
  </ion-segment-button>
</ion-segment>
